import PropTypes from 'prop-types';
import cx from 'classnames';

import withBreakpoint from 'core/hocs/withBreakpoint';
import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import styles from './index.styl';

import { SHARE, SHARE_MOBILE } from '../';


function Skeleton({ theme, isMobile }) {
  const {
    borderRadius,
    buttonHeight,
    iconsGap,
  } = theme.controls.socializator;

  const buttons = isMobile ? SHARE_MOBILE : SHARE;

  return (
    <div className={styles.skeleton}>
      <style jsx>{`
        .${styles.item}
          height ${buttonHeight}px
          width ${buttonHeight}px
          border-radius ${borderRadius}px

          & + &
            margin-left ${iconsGap}px
      `}</style>
      {buttons.map(button => (
        <div key={button} className={cx('lb-skeleton', styles.item)} />
      ))}
    </div>
  );
}

Skeleton.propTypes = {
  isMobile: PropTypes.bool,
  theme: themePropTypes(`
    {
      controls: {
        socializator: {
          borderRadius,
          buttonHeight,
          iconsGap,
        },
      }
    }
  `),
};

export default withBreakpoint(withTheme(Skeleton));
